import { Buttons } from "@/components/atoms/Buttons";
import { TermMenus } from "@/data/menus";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { SideMenuList } from "@/components/molecules/SideMenuList";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const TermsListPage = () => {
  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="설정"
          onClick={() => window.history.back()}
        />
      }
      pageTitle="약관 및 정책"
    >
      <SideMenuList data={TermMenus} />
    </MainTemplate>
  );
};
